import module from 'cliente/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class ClienteInformacionBancosEditarComponent {
  idCliente
  idCuenta
  idDocumento
  editar = false
  catalogo = {
    banco: [],
    moneda: [],
  }
  onClose

  constructor ($q, CatalogoBancos, CatalogoMonedas, ClienteInformacionBancosBanco) {
    this.$q = $q
    this.CatalogoBancosService = CatalogoBancos
    this.CatalogoMonedasService = CatalogoMonedas
    this.ClienteInformacionBancosBancoService = ClienteInformacionBancosBanco
  }

  $onInit () {
    this.promise = this.$q.all([
      this.CatalogoBancosService.get()
        .then(({data}) => (this.catalogo.banco = orderBy(data, ['descripcion']))),
      this.CatalogoMonedasService.get()
        .then(({data}) => (this.catalogo.moneda = orderBy(data, ['descripcion']))),
      this.ClienteInformacionBancosBancoService.get(this.idCliente, this.idCuenta)
        .then(({data}) => (this.data = data)),
    ])
  }

  cerrar (data) {
    if (data) {
      this.onClose({$event: {detail: this.data}})
    }

    this.editar = false
  }
}

module.component('clienteInformacionBancosEditar', {
  controller: ClienteInformacionBancosEditarComponent,
  template,
  bindings: {
    idCliente: '<',
    idCuenta: '<',
    idDocumento: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/bancos/editar/component.js